import { IWarehouseRepository } from 'users/domain/IWarehouseRepository'
import { WarehouseResponse } from 'users/domain/warehouse'

export class GetUserWarehouseUseCase {
    private warehouseRepository: IWarehouseRepository

    constructor(warehouseRepository: IWarehouseRepository) {
        this.warehouseRepository = warehouseRepository
    }

    async execute(): Promise<WarehouseResponse> {
        try {
            const response = await this.warehouseRepository.get()
            return response
        } catch (error) {
            return {
                error: 'true',
                items: [],
                messages: 'Error al obtener elalmacén',
            }
        }
    }
}
